'use client';

import { useState } from 'react';

import { Button, ButtonVariant } from '@bytel/trilogy-react';

import { getPlanPrice } from '@services/products';

import { MobilePlanType } from '@app-types/plan';
import { Product } from '@app-types/product';
import { UserType, UserTypeEnum } from '@app-types/user';

import { ModalPlanDetails } from '@components/product-details-modal';

import { MarketingsState } from '@hooks/use-marketings';

import { PlanRange, PlanTypeId } from '@constants/plan';

type ModalPlanDetailsContainerProps = {
    user?: UserType;
    offerSelectedForDetails: MobilePlanType;
    onClose: () => void;
    onAddToCart: (offer: MobilePlanType) => Promise<void>;
    phoneInCart: Product | undefined;
    marketingDiscounts: MarketingsState;
    isRenewal: boolean;
};

export function ModalPlanDetailsContainer({
    user,
    offerSelectedForDetails,
    onClose,
    onAddToCart,
    phoneInCart,
    marketingDiscounts,
    isRenewal,
}: ModalPlanDetailsContainerProps) {
    const [isLoading, setIsLoading] = useState(false);
    return (
        <ModalPlanDetails
            plan={offerSelectedForDetails}
            price={getPlanPrice(marketingDiscounts, offerSelectedForDetails)}
            isOpen={!!offerSelectedForDetails}
            onClose={onClose}
            isRenewal={isRenewal}
            showBlockedCheckbox
        >
            {offerSelectedForDetails &&
            !(
                isRenewal &&
                user?.user_type === UserTypeEnum.CDC &&
                offerSelectedForDetails.isOwned &&
                (offerSelectedForDetails.typeId.includes(PlanTypeId.SOWO) ||
                    offerSelectedForDetails.commercialRange === PlanRange.WITHOUT_MOBILE)
            ) ? (
                <Button
                    loading={isLoading}
                    onClick={async () => {
                        setIsLoading(true);
                        await onAddToCart(offerSelectedForDetails);
                        setIsLoading(false);
                    }}
                    variant={ButtonVariant.CONVERSION}
                >
                    {phoneInCart || offerSelectedForDetails?.commercialRange !== PlanRange.WITH_MOBILE
                        ? 'Choisir ce forfait'
                        : 'Choisir un téléphone'}
                </Button>
            ) : undefined}
        </ModalPlanDetails>
    );
}
